export default "__VITE_ASSET__fINMcoT___"